import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import store from './store'; // 导入 Vuex store
import dataV from '@kjgl77/datav-vue3'
const app=createApp(App)
app.use(router)
//dataV
app.use(dataV)
app.use(store); // 注册 Vuex store
app.use(ElementPlus)
app.mount('#app')

